// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Link = require("next/link").default;
let AuthSession = require("../../../utils/AuthSession.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let NotificationsAndAlertsUtilsAgent_agent_graphql = require("../../../__generated__/NotificationsAndAlertsUtilsAgent_agent_graphql.bs.js");
let NotificationsAndAlertsUtilsAgent_agentId_graphql = require("../../../__generated__/NotificationsAndAlertsUtilsAgent_agentId_graphql.bs.js");
let NotificationsAndAlertsUtilsForSale_agent_graphql = require("../../../__generated__/NotificationsAndAlertsUtilsForSale_agent_graphql.bs.js");
let NotificationsAndAlertsUtilsForSale_agentId_graphql = require("../../../__generated__/NotificationsAndAlertsUtilsForSale_agentId_graphql.bs.js");
let NotificationsAndAlertsUtilsClientLabel_client_graphql = require("../../../__generated__/NotificationsAndAlertsUtilsClientLabel_client_graphql.bs.js");
let NotificationsAndAlertsUtilsPropertyLocationLabel_property_graphql = require("../../../__generated__/NotificationsAndAlertsUtilsPropertyLocationLabel_property_graphql.bs.js");

let convertFragment = NotificationsAndAlertsUtilsPropertyLocationLabel_property_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationsAndAlertsUtilsPropertyLocationLabel_property_graphql.node, convertFragment, fRef);
}

function readInline(fRef) {
  return RescriptRelay_Fragment.readInlineData(NotificationsAndAlertsUtilsPropertyLocationLabel_property_graphql.node, convertFragment, fRef);
}

let LocationFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  readInline: readInline
};

function getLabel(location, withLinksOpt) {
  let withLinks = withLinksOpt !== undefined ? withLinksOpt : false;
  let location$1 = RescriptRelay_Fragment.readInlineData(NotificationsAndAlertsUtilsPropertyLocationLabel_property_graphql.node, convertFragment, location);
  let match = location$1.propertyLocation;
  let text;
  if (match !== undefined) {
    switch (match.__typename) {
      case "PropertyLocationWithHiddenAddress" :
        let locationDisplay = match.locationDisplay;
        text = locationDisplay !== undefined ? locationDisplay : "-";
        break;
      case "PropertyLocationWithVisibleAddress" :
        let locationDisplay$1 = match.address;
        text = locationDisplay$1 !== undefined ? locationDisplay$1 : "-";
        break;
      case "__unselected" :
        text = "-";
        break;
    }
  } else {
    text = "-";
  }
  if (withLinks) {
    return JsxRuntime.jsx(Link, {
      href: `/properties/` + location$1.id,
      children: text
    });
  } else {
    return text;
  }
}

let PropertyLocationLabel = {
  LocationFragment: LocationFragment,
  getLabel: getLabel
};

let convertFragment$1 = NotificationsAndAlertsUtilsClientLabel_client_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationsAndAlertsUtilsClientLabel_client_graphql.node, convertFragment$1, fRef);
}

function readInline$1(fRef) {
  return RescriptRelay_Fragment.readInlineData(NotificationsAndAlertsUtilsClientLabel_client_graphql.node, convertFragment$1, fRef);
}

let ClientFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  readInline: readInline$1
};

function getLabel$1(client, withLinksOpt) {
  let withLinks = withLinksOpt !== undefined ? withLinksOpt : false;
  let client$1 = RescriptRelay_Fragment.readInlineData(NotificationsAndAlertsUtilsClientLabel_client_graphql.node, convertFragment$1, client);
  if (withLinks) {
    return JsxRuntime.jsx(Link, {
      href: `/clients/` + client$1.id,
      children: client$1.displayName
    });
  } else {
    return client$1.displayName;
  }
}

let ClientLabel = {
  ClientFragment: ClientFragment,
  getLabel: getLabel$1
};

let convertFragment$2 = NotificationsAndAlertsUtilsAgent_agent_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationsAndAlertsUtilsAgent_agent_graphql.node, convertFragment$2, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationsAndAlertsUtilsAgent_agent_graphql.node, convertFragment$2, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, NotificationsAndAlertsUtilsAgent_agent_graphql.node, convertFragment$2);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(NotificationsAndAlertsUtilsAgent_agent_graphql.node, convertFragment$2, fRef);
}

let Agent = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function useAgentTextOpt(fragmentRefs, withLinksOpt) {
  let withLinks = withLinksOpt !== undefined ? withLinksOpt : false;
  let currentUserId = AuthSession.useCurrentUserId();
  let data = useOpt(fragmentRefs);
  if (data === undefined) {
    return "A TAN agent";
  }
  let agentId = data.id;
  let displayName = data.displayName;
  if (currentUserId !== undefined && currentUserId === agentId) {
    return "You";
  }
  if (withLinks) {
    return JsxRuntime.jsx(Link, {
      href: `/agents/` + agentId,
      children: displayName
    });
  } else {
    return displayName;
  }
}

function useAgentText(fragmentRefs, withLinksOpt) {
  let withLinks = withLinksOpt !== undefined ? withLinksOpt : false;
  return useAgentTextOpt(Primitive_option.some(fragmentRefs), withLinks);
}

let convertFragment$3 = NotificationsAndAlertsUtilsForSale_agent_graphql.Internal.convertFragment;

function waitForFragmentData$3(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationsAndAlertsUtilsForSale_agent_graphql.node, convertFragment$3, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationsAndAlertsUtilsForSale_agent_graphql.node, convertFragment$3, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, NotificationsAndAlertsUtilsForSale_agent_graphql.node, convertFragment$3);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(NotificationsAndAlertsUtilsForSale_agent_graphql.node, convertFragment$3, fRef);
}

let ForSaleAgent = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$3,
  waitForFragmentData: waitForFragmentData$3,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function useForSaleAgentText(fragmentRefs) {
  let data = RescriptRelay_Fragment.useFragment(NotificationsAndAlertsUtilsForSale_agent_graphql.node, convertFragment$3, fragmentRefs);
  let fragmentRef;
  switch (data.__typename) {
    case "VisibleForSalePropertyAgent" :
      let match = data.agent;
      fragmentRef = match !== undefined ? Primitive_option.some(match.fragmentRefs) : undefined;
      break;
    case "AnonymousForSalePropertyAgent" :
    case "__unselected" :
      fragmentRef = undefined;
      break;
  }
  let text = useAgentTextOpt(fragmentRef, undefined);
  switch (data.__typename) {
    case "AnonymousForSalePropertyAgent" :
      return "A TAN agent";
    case "VisibleForSalePropertyAgent" :
    case "__unselected" :
      return text;
  }
}

let AgentText = {
  Agent: Agent,
  useAgentTextOpt: useAgentTextOpt,
  useAgentText: useAgentText,
  ForSaleAgent: ForSaleAgent,
  useForSaleAgentText: useForSaleAgentText
};

let convertFragment$4 = NotificationsAndAlertsUtilsAgent_agentId_graphql.Internal.convertFragment;

function waitForFragmentData$4(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationsAndAlertsUtilsAgent_agentId_graphql.node, convertFragment$4, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationsAndAlertsUtilsAgent_agentId_graphql.node, convertFragment$4, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, NotificationsAndAlertsUtilsAgent_agentId_graphql.node, convertFragment$4);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(NotificationsAndAlertsUtilsAgent_agentId_graphql.node, convertFragment$4, fRef);
}

let Agent$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$4,
  waitForFragmentData: waitForFragmentData$4,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function useAgentId(fragmentRefs) {
  return RescriptRelay_Fragment.useFragment(NotificationsAndAlertsUtilsAgent_agentId_graphql.node, convertFragment$4, fragmentRefs).id;
}

let convertFragment$5 = NotificationsAndAlertsUtilsForSale_agentId_graphql.Internal.convertFragment;

function waitForFragmentData$5(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationsAndAlertsUtilsForSale_agentId_graphql.node, convertFragment$5, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationsAndAlertsUtilsForSale_agentId_graphql.node, convertFragment$5, fRef);
}

function useOpt$3(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, NotificationsAndAlertsUtilsForSale_agentId_graphql.node, convertFragment$5);
}

function readResolverFragment$3(fRef) {
  return RescriptRelay_Fragment.read(NotificationsAndAlertsUtilsForSale_agentId_graphql.node, convertFragment$5, fRef);
}

let ForSaleAgent$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$5,
  waitForFragmentData: waitForFragmentData$5,
  use: use$3,
  useOpt: useOpt$3,
  readResolverFragment: readResolverFragment$3
};

function useForSaleAgentId(fragmentRefs) {
  let data = RescriptRelay_Fragment.useFragment(NotificationsAndAlertsUtilsForSale_agentId_graphql.node, convertFragment$5, fragmentRefs);
  if (data.__typename !== "VisibleForSalePropertyAgent") {
    return;
  }
  let match = data.agent;
  if (match !== undefined) {
    return match.id;
  }
}

let AgentId = {
  Agent: Agent$1,
  useAgentId: useAgentId,
  ForSaleAgent: ForSaleAgent$1,
  useForSaleAgentId: useForSaleAgentId
};

exports.PropertyLocationLabel = PropertyLocationLabel;
exports.ClientLabel = ClientLabel;
exports.AgentText = AgentText;
exports.AgentId = AgentId;
/* next/link Not a pure module */
